<template>
    <main>
		<HeaderTab 
            :title="$t('global.feed')"
            :icon="['fal', 'rss']"
        />

        <div id="content">
            <NotesFeed />
        </div>
	</main>
</template>


<script type="text/javascript">
	export default {
		name: "feed",
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
			NotesFeed: () => import('@/components/Dedicated/Notes/Feed')
		}
	}
</script>
